import { motion } from 'framer-motion';
import styled from 'styled-components';

export const RingsFrame = styled.div<{ $left: number; $size: number; $top: number }>`
  position: absolute;
  left: ${({ $left }) => `${$left}px`};
  top: ${({ $top }) => `${$top}px`};
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
`;

// Sized wrapper so motion scale transforms originate from the ring's center
export const Ring = styled(motion.div)`
  position: absolute;
  inset: 0;

  svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;
